(() => {
  'use strict';
  const configElement = document.getElementById('bos-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const dialog = document.getElementById('bos-cart');
  const storageKey = `bos-cart:${config.domain}`;
  let cart = null;
  let pending = false;
  const fragment = `id checkoutUrl totalQuantity cost { totalAmount { amount currencyCode } } lines(first:100) { edges { node { id quantity cost { totalAmount { amount currencyCode } } merchandise { ... on ProductVariant { id title product { title handle } } } } } }`;
  const money = (value) => new Intl.NumberFormat('en-US', {style:'currency',currency:value.currencyCode}).format(Number(value.amount));
  const cartId = () => {try{return localStorage.getItem(storageKey)}catch{return null}};
  function saveCart(next) {
    cart = next;
    try {if (next) localStorage.setItem(storageKey,next.id);else localStorage.removeItem(storageKey)}catch{}
    renderCart();
  }
  async function storefrontApiRequest(query, variables = {}) {
    if (!config.token || !config.domain) throw new Error('The store is not configured for checkout yet. Please contact the seller.');
    const response = await fetch(`https://${config.domain}/api/2026-10/graphql.json`, {
      method:'POST', headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':config.token},body:JSON.stringify({query,variables})
    });
    if (response.status === 402) throw new Error('Shopify requires an active billing plan before checkout is available.');
    if (!response.ok) throw new Error('Shopify is unreachable. Please try again.');
    const result = await response.json();
    if (result.errors?.length) throw new Error(result.errors.map(e=>e.message).join('; '));
    return result.data;
  }
  function showError(error) {
    document.querySelectorAll('[data-cart-error], [data-buy-error]').forEach(el=>el.textContent=error?.message || 'Please try again.');
    if (!document.querySelector('[data-buy-error]')) openCart();
  }
  function openCart() {if(dialog && !dialog.open) dialog.showModal()}
  const upsellDialog=document.getElementById('bos-upsell');
  const variantByHandle={};
  function cartHasClientKit(){return !!(cart?.lines.edges||[]).some(function(e){return e.node.merchandise.product.handle===config.clientKitHandle})}
  function closeUpsell(){if(upsellDialog&&upsellDialog.open)upsellDialog.close()}
  function openUpsell(){if(upsellDialog&&!upsellDialog.open)upsellDialog.showModal()}
  function afterAdd(handle){
    if(handle===config.clientKitHandle){closeUpsell();openCart();return}
    if(handle!==config.handle || !config.clientKitHandle || !variantByHandle[config.clientKitHandle] || cartHasClientKit()){openCart();return}
    openUpsell();
  }
  function clearError() {document.querySelectorAll('[data-cart-error],[data-buy-error]').forEach(el=>el.textContent='')}
  function lineElement(line) {
    const article = document.createElement('article');article.className='bos-cart-line';
    const a=document.createElement('a');a.className='font-bold';a.href=`/products/${encodeURIComponent(line.merchandise.product.handle)}`;a.textContent=line.merchandise.product.title;
    const amount=document.createElement('p');amount.className='mt-2';amount.textContent=money(line.cost.totalAmount);
    const controls=document.createElement('div');controls.className='bos-line-controls';
    const count=document.createElement('span');count.textContent=String(line.quantity);
    const makeButton=(text,label,quantity)=>{const b=document.createElement('button');b.type='button';b.textContent=text;b.setAttribute('aria-label',label);b.disabled=pending;b.addEventListener('click',()=>updateLine(line.id,quantity));return b};
    controls.append(makeButton('−','Decrease quantity',line.quantity-1),count,makeButton('+','Increase quantity',line.quantity+1),makeButton('✕','Remove item',0));article.append(a,amount,controls);return article;
  }
  function renderCart() {
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart?.totalQuantity || 0));
    document.querySelectorAll('[data-cart-lines],[data-inline-cart]').forEach(el=>{
      el.replaceChildren();const lines=cart?.lines.edges || [];
      if(!lines.length){const p=document.createElement('p');p.textContent='Your cart is empty.';el.append(p)}
      lines.forEach(({node})=>el.append(lineElement(node)));
    });
    document.querySelectorAll('[data-cart-total]').forEach(el=>el.textContent=cart ? `Total: ${money(cart.cost.totalAmount)}` : '');
    document.querySelectorAll('[data-checkout]').forEach(el=>el.disabled=pending || !cart?.totalQuantity);
  }
  async function syncCart() {
    const id=cartId();if(!id){saveCart(null);return}
    const data=await storefrontApiRequest(`query($id:ID!){cart(id:$id){${fragment}}}`,{id});saveCart(data.cart);
  }
  function acceptMutation(result) {
    if(result.userErrors?.length)throw new Error(result.userErrors.map(e=>e.message).join('; '));
    if(!result.cart)throw new Error('Shopify did not confirm your cart. Please try again.');saveCart(result.cart);
  }
  async function createShopifyCart(variantId) {
    const data=await storefrontApiRequest(`mutation($input:CartInput!){cartCreate(input:$input){cart{${fragment}}userErrors{message}}}`,{input:{lines:[{merchandiseId:variantId,quantity:1}]}});acceptMutation(data.cartCreate);
  }
  async function addItem(variantId, handle) {
    if(pending)return;pending=true;clearError();renderCart();
    try {
      await syncCart();
      if(!cart)await createShopifyCart(variantId);
      else {
        const data=await storefrontApiRequest(`mutation($cartId:ID!,$lines:[CartLineInput!]!){cartLinesAdd(cartId:$cartId,lines:$lines){cart{${fragment}}userErrors{message}}}`,{cartId:cart.id,lines:[{merchandiseId:variantId,quantity:1}]});acceptMutation(data.cartLinesAdd);
      }
      afterAdd(handle);
    }catch(e){showError(e)}finally{pending=false;renderCart()}
  }
  async function updateLine(id,quantity) {
    if(pending || !cart)return;pending=true;clearError();renderCart();
    try {
      if(quantity<=0){const data=await storefrontApiRequest(`mutation($cartId:ID!,$lineIds:[ID!]!){cartLinesRemove(cartId:$cartId,lineIds:$lineIds){cart{${fragment}}userErrors{message}}}`,{cartId:cart.id,lineIds:[id]});acceptMutation(data.cartLinesRemove)}
      else {const data=await storefrontApiRequest(`mutation($cartId:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$cartId,lines:$lines){cart{${fragment}}userErrors{message}}}`,{cartId:cart.id,lines:[{id,quantity}]});acceptMutation(data.cartLinesUpdate)}
    }catch(e){showError(e)}finally{pending=false;renderCart()}
  }
  // Synchronous window.open keeps browser permission tied to the actual click.
  document.querySelectorAll('[data-checkout]').forEach(el=>el.addEventListener('click',()=>{
    if(!cart?.totalQuantity || !cart.checkoutUrl || pending)return;
    const url=new URL(cart.checkoutUrl);url.searchParams.set('channel','online_store');
    try{const d=localStorage.getItem('viora-discount');if(d)url.searchParams.set('discount',d)}catch{}
    window.open(url.toString(),'_blank','noopener,noreferrer');
  }));
  document.querySelectorAll('[data-open-cart]').forEach(el=>el.addEventListener('click',openCart));
  document.querySelectorAll('[data-close-cart]').forEach(el=>el.addEventListener('click',()=>dialog?.close()));
  dialog?.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom)dialog.close()}});
  if(upsellDialog){
    upsellDialog.addEventListener('close',openCart);
    upsellDialog.addEventListener('click',e=>{const r=upsellDialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom)upsellDialog.close()});
    upsellDialog.querySelector('[data-upsell-yes]')?.addEventListener('click',()=>{const v=variantByHandle[config.clientKitHandle];if(v)addItem(v,config.clientKitHandle)});
    upsellDialog.querySelector('[data-upsell-no]')?.addEventListener('click',()=>upsellDialog.close());
  }
  // Only API-confirmed variants can become buyable; no mock fallback.
  async function prepareBuyButtons() {
    const buttons=[...document.querySelectorAll('[data-buy]')];
    const handles=[...new Set(buttons.map(el=>el.dataset.productHandle || config.handle))];
    for(const handle of handles){
      try {
        const data=await storefrontApiRequest('query($handle:String!){product(handle:$handle){variants(first:100){nodes{id availableForSale}}}}',{handle});
        const variants=data.product?.variants.nodes || [];
        const available=variants.find(v=>v.availableForSale);
        buttons.filter(el=>(el.dataset.productHandle || config.handle)===handle).forEach(el=>{
          if(!available){el.textContent=data.product?'Sold out':'No products found';return}
          el.disabled=false;
          variantByHandle[handle]=available.id;
          el.addEventListener('click',()=>{const select=document.getElementById('product-variant');const id=select?.value || available.id;if(!variants.some(v=>v.id===id && v.availableForSale)){showError(new Error('This option is not available.'));return}addItem(id,el.dataset.productHandle || config.handle)});
        });
      }catch(e){buttons.filter(el=>(el.dataset.productHandle || config.handle)===handle).forEach(el=>{el.textContent='Currently unavailable'});console.warn('Notion Viora checkout unavailable');}
    }
  }
  document.querySelectorAll('[data-demo-link]').forEach(el=>el.addEventListener('click',()=>{
    const detail={event:'demo_click',link_url:el.href};
    window.dispatchEvent(new CustomEvent('demo_click',{detail}));
    if(typeof window.gtag==='function')window.gtag('event','demo_click',{link_url:el.href});else if(Array.isArray(window.dataLayer))window.dataLayer.push(detail);
  }));
  const tabs=[...document.querySelectorAll('[data-module-tab]')];
  function activateTab(tab){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;t.className=active?'shrink-0 snap-start rounded-full px-4 py-2 text-sm font-semibold transition-colors bg-gradient-brand text-primary-foreground':'shrink-0 snap-start rounded-full px-4 py-2 text-sm font-semibold transition-colors border bg-card text-muted-foreground hover:text-foreground'});document.querySelectorAll('[data-module-panel]').forEach(p=>p.hidden=p.dataset.modulePanel!==tab.dataset.moduleTab)}
  tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activateTab(tab));tab.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%tabs.length;else if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activateTab(tabs[next]);tabs[next].focus()})});
  const mobile=document.querySelector('[data-mobile-bar]');
  function scrollState(){if(mobile)mobile.hidden=window.scrollY<=window.innerHeight*.9;document.querySelector('header')?.classList.toggle('shadow-card',window.scrollY>10)}
  window.addEventListener('scroll',scrollState,{passive:true});scrollState();
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible' && !pending)syncCart().catch(showError)});
  renderCart();syncCart().catch(showError);prepareBuyButtons();
})();

/* Motion layer v1.1: scroll reveal + counters */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('bos-js');
  var targets=[];
  document.querySelectorAll('main section:not(#top)').forEach(function(s){
    var kids=s.querySelectorAll('h2, h3, p, [class*="rounded-2xl"], [class*="rounded-3xl"], details, img');
    var i=0;kids.forEach(function(el){if(el.closest('.bos-reveal'))return;el.classList.add('bos-reveal');el.style.setProperty('--bos-d',(Math.min(i++,6)*0.07)+'s');targets.push(el);});
  });
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  targets.forEach(function(t){io.observe(t)});
  setTimeout(function(){targets.forEach(function(t){t.classList.add('is-in')})},4000);
  var nums=[];document.querySelectorAll('main section:not(#top) *').forEach(function(el){
    if(el.children.length)return;var m=/^(\D*)(\d{1,4})(\D{0,3})$/.exec((el.textContent||'').trim());
    if(m&&!/€|\$/.test(m[1]+m[3])&&+m[2]>1){el.dataset.bosN=m[2];el.dataset.bosP=m[1];el.dataset.bosS=m[3];nums.push(el);}
  });
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;cio.unobserve(e.target);var el=e.target,n=+el.dataset.bosN,t0=performance.now();
    (function step(t){var k=Math.min((t-t0)/1100,1);el.textContent=el.dataset.bosP+Math.round(n*(1-Math.pow(1-k,3)))+el.dataset.bosS;if(k<1)requestAnimationFrame(step);})(t0);});},{threshold:.6});
  nums.forEach(function(n){cio.observe(n)});
})();

/* Motion layer v1.2: feature micro-mockups (hover + autoplay) and step line */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards=[].slice.call(document.querySelectorAll('#funzioni article'));
  var H=[40,70,55,90];
  function set(card,i,on){
    card.classList.toggle('bos-on',on&&card.matches(':hover'));
    var m=card.querySelector('div[aria-hidden].mt-5');if(!m)return;
    if(i===0)[].forEach.call(m.querySelectorAll('.space-y-1>div'),function(r,k){r.style.transform='translateX('+(on?0:(2-k)*6)+'px)';r.style.opacity=on?1:.6;r.style.transitionDelay=(k*.05)+'s';});
    if(i===1){var b=m.querySelector('b');if(b)b.textContent=(on?'13':'7')+' days';m.firstElementChild.style.transform='scale('+(on?1:.96)+')';}
    if(i===2){var s=m.querySelector('.text-destructive');if(s)s.style.opacity=on?1:.4;}
    if(i===3)[].forEach.call(m.querySelectorAll('.bg-success'),function(b,k){b.style.height=(on?H[k]:20)+'%';});
    if(i===4){var g=m.querySelector('.bg-gradient-brand');if(g)g.style.width=on?'49%':'10%';}
    if(i===5){var e=m.querySelector('b');if(e)e.style.opacity=on?1:.5;}
  }
  cards.forEach(function(c,i){
    c.dataset.bosI=i;set(c,i,false);
    c.addEventListener('mouseenter',function(){c.dataset.bosHover=1;set(c,i,true);c.classList.add('bos-on');});
    c.addEventListener('mouseleave',function(){c.dataset.bosHover='';c.classList.remove('bos-on');set(c,i,false);});
  });
  if(!reduce&&cards.length){
    var vis=false;
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){vis=es[0].isIntersecting;},{threshold:.2}).observe(document.getElementById('funzioni'));}else vis=true;
    var tick=0;setInterval(function(){
      if(!vis||document.hidden)return;tick++;
      cards.forEach(function(c,i){if(c.dataset.bosHover)return;set(c,i,((tick+i)%4)<2);});
    },1300);
  }
  var line=document.querySelector('svg line[pathlength]');
  if(line&&!reduce&&'IntersectionObserver' in window){line.classList.add('bos-line');
    var o=new IntersectionObserver(function(es){if(es[0].isIntersecting){line.classList.add('is-in');o.disconnect();}},{threshold:.5});o.observe(line);}
})();
